import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1ContextRetrieve: build.query<
      ApiPortalV1ContextRetrieveApiResponse,
      ApiPortalV1ContextRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/context/` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1ContextRetrieveApiResponse =
  /** status 200  */ UserContextRead;
export type ApiPortalV1ContextRetrieveApiArg = void;
export type RoleEnum = 1 | 2 | 3 | 4;
export type Account = {
  email: string;
  first_name: string;
  last_name?: string | null;
  email_confirmed?: boolean;
  resend_conf?: number;
  last_login?: string | null;
  cognito_id?: string | null;
  role?: RoleEnum;
  guided_experience_state?: any | null;
};
export type AccountRead = {
  id: number;
  email: string;
  first_name: string;
  last_name?: string | null;
  is_active: string;
  status: string;
  email_confirmed?: boolean;
  resend_conf?: number;
  last_login?: string | null;
  cognito_id?: string | null;
  role?: RoleEnum;
  guided_experience_state?: any | null;
};
export type AccountType71FEnum = 3 | 4 | 5 | 9;
export type Status68DEnum = 1 | 2 | 3 | 98 | 99 | 100;
export type SurveyStatus034Enum = 1 | 2;
export type EmployeeShort = {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  account_type?: AccountType71FEnum;
  status?: Status68DEnum;
  survey_status?: SurveyStatus034Enum;
};
export type EmployeeShortRead = {
  id: number;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  account_type?: AccountType71FEnum;
  status?: Status68DEnum;
  survey_status?: SurveyStatus034Enum;
};
export type EmailStatusEnum = 1 | 2 | 3 | 4 | 9;
export type Employee = {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  status?: Status68DEnum;
  account?: number | null;
  organization: number;
  manager?: number | null;
  department?: number | null;
  email_status?: EmailStatusEnum;
  account_type?: AccountType71FEnum;
  survey_status?: SurveyStatus034Enum;
};
export type EmployeeRead = {
  id: number;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  status?: Status68DEnum;
  account?: number | null;
  organization: number;
  manager?: number | null;
  department?: number | null;
  created_at: string;
  updated_at: string;
  email_status?: EmailStatusEnum;
  email_status_text: string;
  status_text: string;
  account_type?: AccountType71FEnum;
  account_type_text: string;
  survey_status?: SurveyStatus034Enum;
};
export type AssessmentPeriodStatusEnum = 1 | 2 | 3;
export type AssessmentPeriod = {
  name?: string;
  organization: number;
  status?: AssessmentPeriodStatusEnum;
  start_date_time: string;
  end_date_time: string;
  survey_question?: number | null;
  outcome_question?: number | null;
  min_followup_questions?: number;
  max_followup_questions?: number;
  survey_question_structure?: any | null;
  outcome_question_structure?: any | null;
  categories?: any | null;
  /** Enable automated reminder emails. Defaults to True. Schedule inherits from organization.default_reminder_schedule if not set. */
  reminder_enabled?: boolean;
  /** Cron expression for reminder schedule (e.g., '0 9 * * 1,3,5' for Mon/Wed/Fri at 9am in organization's timezone). If not set, inherits from organization.default_reminder_schedule. */
  reminder_schedule?: string | null;
};
export type AssessmentPeriodRead = {
  id: number;
  name?: string;
  organization: number;
  status?: AssessmentPeriodStatusEnum;
  start_date_time: string;
  end_date_time: string;
  survey_question?: number | null;
  outcome_question?: number | null;
  min_followup_questions?: number;
  max_followup_questions?: number;
  survey_question_structure?: any | null;
  outcome_question_structure?: any | null;
  categories?: any | null;
  brief_token: string | null;
  debrief_schedule_id: number | null;
  /** Enable automated reminder emails. Defaults to True. Schedule inherits from organization.default_reminder_schedule if not set. */
  reminder_enabled?: boolean;
  /** Cron expression for reminder schedule (e.g., '0 9 * * 1,3,5' for Mon/Wed/Fri at 9am in organization's timezone). If not set, inherits from organization.default_reminder_schedule. */
  reminder_schedule?: string | null;
};
export type OrganizationWithDepartments = {
  id: number;
  name: string;
  members: EmployeeShort[];
  employee?: Employee;
  assessment_periods: AssessmentPeriod[];
  employee_records_enabled: boolean;
  default_max_followup: number;
  default_min_followup: number;
  default_outcome_question: number;
  default_survey_question: number;
  default_reminder_schedule: string;
  tier: number;
};
export type OrganizationWithDepartmentsRead = {
  id: number;
  name: string;
  members: EmployeeShortRead[];
  employee?: EmployeeRead;
  assessment_periods: AssessmentPeriodRead[];
  employee_records_enabled: boolean;
  default_max_followup: number;
  default_min_followup: number;
  default_outcome_question: number;
  default_survey_question: number;
  default_reminder_schedule: string;
  tier: number;
};
export type UserContext = {
  account: Account;
  organizations: OrganizationWithDepartments[];
};
export type UserContextRead = {
  account: AccountRead;
  organizations: OrganizationWithDepartmentsRead[];
};
export const { useApiPortalV1ContextRetrieveQuery } = injectedRtkApi;
